import React from 'react'

const ModalInconsistenciasEnLiquidacionQx = ({dataProcedimientos,setmodalOnInconsistencia, item}) => {
    const [loading, setLoading] = React.useState(true);
    const handleCancelClick=()=>{
        setmodalOnInconsistencia(false)
    }
  return (
    <div
    className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
    id="exampleModalScrollable"
    tabIndex="-1"
    aria-labelledby="exampleModalScrollableLabel"
    aria-hidden="true"
  >
    <div className="sm:h-[calc(100%)]   mx-auto relative w-auto pointer-events-none ">
      <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
        <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md  bg-[#05a29d]">
          <h5
            className="text-xl font-medium leading-normal text-white"
            id="exampleModalScrollableLabel"
          >
            Inconsistencias en Liquidación de los procedimiento Cirugía
          </h5>
          <button
            type="button"
            onClick={handleCancelClick}
            className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            X
          </button>
        </div>
       
          <div className="flex-auto overflow-y-auto relative p-1">
           
            <div className="flex-auto overflow-y-auto relative p-1">     
              {/* <div className="flex flex-row py-1  text-left">
                <div className="w-1/3  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Tipo Documento
                  </label>           
                  <input
                    defaultValue={item.MPTDoc}                      
                    disabled={true}
                    type="text"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                </div>
                <div className="w-1/3  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Número Documento
                  </label>
                  <input
                    disabled={true}
                    defaultValue={item.MPCedu}                      
                    type="text"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                </div>
                <div className="w-1/3  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Nombre Paciente
                  </label>
                  <input
                    disabled={true}
                    defaultValue={item.MPNOMC}                      
                    type="text"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                </div>
                
              </div> */}
              
              <div className="flex flex-row py-1  text-left">
              <div className="w-3/3  px-1 ">
              
              <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
              Se detectaron inconsistencias en el tipo de paquete o en las formas de liquidación. Por favor, verifica en la siguiente tabla.
                  </label>
              </div>
              </div>
              
              
              <div className="flex flex-row py-1  text-left">   
              </div>
          <div className="text-center bg-[#05a29d] pb-1">
            <label
              htmlFor="exampleFormControlInput1"
              className="form-label inline-block mt-1 text-white font-medium px-1 text-xl "
            >
              Procedimientos quirúrgicos
            </label>
          </div>

          <div className="">
            <div className="flex flex-col">
              <div className="overflow-x-auto ">
                <div className="py-1 inline-block min-w-full ">
                  <div className="overflow-hidden">
                    <table className="min-w-full text-center bg-gray-200">
                      <thead className="">
                        <tr>
                        <th
                            scope="col"
                            className="text-sm font-medium text-gray-900"
                          >                              
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-4 py-2"
                          >
                            Codigo Qx
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-4 py-2"
                          >
                            Descripción
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-4 py-2"
                          >
                            Es tipo Paquete?
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-4 py-2"
                          >
                            Formas de Liquidación?
                          </th>
                        </tr>
                      </thead>

                      {
                        
                        dataProcedimientos.map((item)=>(
                          <tbody>
                            <tr className="divide-y divide-slate-700">
                              <td></td>
                            
                              <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap text-left">
                               
                                {item.PRCODI}
                              </td>
                              <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap text-left">
                                
                                {item.PrNomb}
                              </td>
                              
                              <td className="text-xs text-gray-900 font-medium px-8  whitespace-pre-wrap">{item.PTIndPaq === 'S'? 'Si' : 'No'}</td>
                              <td className="text-xs text-gray-900 font-medium px-8  whitespace-pre-wrap">{item.ForLiqCod}</td>
                            </tr>
                            
                          </tbody>
                        ))
                        
                        
                      }
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
            <button
              type="button"
              onClick={handleCancelClick}
              className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              Cancelar
            </button>
           
          </div>
            </div>
            
          </div>
      </div>
      {
          loading? null:
          
          <div className="relative flex items-center justify-center h-screen">
          <div className="fixed top-0 left-0 flex items-center justify-center w-full h-full bg-slate-900 bg-opacity-25" style={{ pointerEvents: "auto" }}>
              <div className="flex flex-col items-center justify-center p-6 bg-white rounded shadow-lg">
                  <div className="w-16 h-16 border-t-4 border-blue-500 rounded-full animate-spin"></div>
                  <p className="mt-4 text-lg">Cargando</p>
              </div>
          </div>
          <div className="absolute top-0 left-0 w-full h-full" style={{ pointerEvents: "none" }}></div>
      </div>
        }
    </div>
    
    
  </div>
  )
}

export default ModalInconsistenciasEnLiquidacionQx